

//-------------------------------VIVA-APIs-------------------------------------------
export const LoginAPI = "/ondemand/classes_auth/?";
//example - /ondemand/classes_auth/?e=test1@vivaleisure.com.au&p=test1
export const ResetPassword = "/ondemand/password_reset/?e=";
//example - https://api.vivaleisure.com.au/api/ondemand/password_reset/?e=test1@vivaleisure.com.au
export const getUserSubscription = "/ondemand/classes_auth/?token="
 